import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import images from '../constants/images';
import BentoGrid from '../components/BentoGrid';
import DailyCabsSection from '../components/DailyCabsSection';
import RatesTable from "../components/RatesTable";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${images.carimage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backdropFilter: 'blur(5px)',
        }}
        className="bg-fixed"
      >
        <Navbar />
        <section className="py-20 px-4 text-white text-center">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-4xl font-bold mb-6 animate-fade-in-up">
              Welcome to Zab Tours and Travels
            </h1>
            <p className="text-xl text-[#003b6f]">
              Experience premium rides at competitive prices
            </p>
          </div>
        </section>
      </div>

      {/* Daily Cabs Section */}
      <div className="bg-white py-16 px-4 ">
        <div className="max-w-6xl mx-auto text-center">
      <DailyCabsSection />
          </div>
      </div>

      {/* Services Section */}
      <main className="flex-grow">
        <section id="services-section" className="py-16 px-4 bg-gray-50">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-12 text-gray-800">Our Services</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                { id: 1, name: 'Standard Ride', image: images.car1, description: "A budget-friendly ride offering comfort and reliability for your daily travels."  },
                { id: 2, name: 'Premium Ride', image: images.realcar5, description: "Enjoy a stylish and comfortable ride with added luxury and convenience." },
                { id: 3, name: 'Luxury Ride', image: images.realcar1, description: "Indulge in the ultimate luxury experience with our high-end vehicles." },
              ].map((product) => (
                <div
                  key={product.id}
                  className="relative bg-white/10 backdrop-blur-md border border-gray-200 shadow-lg rounded-2xl overflow-hidden transition-all duration-300 hover:drop-shadow-2xl hover:-translate-y-2"
                >
                  {/* Image Section */}
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover transition-transform duration-500 ease-in-out hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  </div>

                  {/* Content Section */}
                  <div className="p-6 text-center">
                    <h3 className="text-2xl font-bold text-gray-800">{product.name}</h3>
                    <p className="text-gray-600 mt-2">
                    {product.description}
                    </p>

                    {/* Button */}
                    <button
                      className="mt-6 w-full bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 text-white font-semibold py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                      onClick={() => navigate('/services')}
                    >
                      Learn More →
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* Rates Table Section */}
        <RatesTable />

        <BentoGrid />

        {/* Testimonials Section */}
        <section className="bg-gray-500 py-16 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6 text-amber-300">What Our Customers Say</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  name: 'Rahul Sharma',
                  location: 'Mumbai, India',
                  feedback: 'The ride was smooth and comfortable. The driver was professional and punctual!',
                },
                {
                  name: 'Sneha Verma',
                  location: 'Delhi, India',
                  feedback: 'Amazing service! The car was clean, and the pricing was very reasonable.',
                },
                {
                  name: 'Arjun Mehta',
                  location: 'Bangalore, India',
                  feedback: 'Reliable and safe rides. I always choose Zab Tours for my business trips.',
                },
              ].map((customer, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                  <p className="text-gray-700 italic">"{customer.feedback}"</p>
                  <div className="mt-4 flex justify-center items-center">
                    {/* <img src={customer.image} alt={customer.name} className="w-12 h-12 rounded-full mr-3" /> */}
                    <div className="text-left">
                      <h3 className="text-lg font-semibold text-gray-800">{customer.name}</h3>
                      <p className="text-gray-500 text-sm">{customer.location}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
